$(function() {
  'use strict';
  const AnimatedModule = require('_module/animatedModule');

  class AnimatedSequenceModule extends AnimatedModule {
    postRender() {
      const repetitions = parseInt(this.$el.data('animation-repeat'), 10) || 1;

      this.isHorizontal = !!this.$el.data('animation-horizontal');
      this.sequenceLength = parseInt(this.animation.sequence, 10) + 1;
      this.length = this.sequenceLength * repetitions;

      this.triggers = this._parseTriggers();
      this.duration = this.triggers.till - this.triggers.from;

      this.frameSize = this.isHorizontal ? this.$el.width() : this.$el.height();

      const backgroundSize = this.frameSize * this.sequenceLength;

      this.$el.css({
        'background-size': this.isHorizontal ? `${backgroundSize}px auto` : `auto ${backgroundSize}px`,
      });
    }

    draw(progress) {
      progress = (progress - this.triggers.from) / this.duration;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      const frame = (progress * (this.length - 1) | 0);
      const frameOffset = (frame % this.sequenceLength) * this.frameSize;

      this.$el.css({
        'background-position': this.isHorizontal ? `-${frameOffset}px 50%` : `50% -${frameOffset}px`,
      });
    }

    _parseTriggers() {
      const fromTrigger = this.$el.data('animation-fromtrigger') || '0%';
      const tillTrigger = this.$el.data('animation-tilltrigger') || '100%';

      return {
        from: this._parseTrigger(fromTrigger),
        till: this._parseTrigger(tillTrigger),
      };
    }

    _parseTrigger(triggerString) {
      return triggerString.replace('%', '') / 100;
    }
  }

  $('.js__animatedSequence').each(function() {
    new AnimatedSequenceModule($(this));
  });
});
